export enum PermissionKeys {
  CAN_EDIT_PLAYERS = "canEditPlayers",
  CAN_EDIT_TEAM = "canEditTeam",
  CAN_EDIT_EVENTS = "canEditEvents",
  CAN_EDIT_FEES = "canEditFees",
  CAN_EDIT_ADMINISTRATORS = "canEditAdministrators",
  CAN_SEND_MESSAGES = "canSendMessages",
  CAN_RECEIVE_AVAILABILITY_EMAILS = "canReceiveAvailabilityEmails",
  CAN_CHAT = "chatEnabled",
  CAN_EDIT_BILLING = "canEditBilling",
  CAN_MANAGE_REGISTRATION = "canManageRegistration",
  CAN_ADD_TEAMS = "canAddNewTeams"
}
export interface UserOrganizationsAndTeams {
  canEditAdministrators: boolean;
  canEditEvents: boolean;
  canEditFees: boolean;
  canEditPlayers: boolean;
  canEditTeam: boolean;
  canReceiveAvailabilityEmails: boolean;
  canSendMessages: boolean;
  canEditBilling: boolean;
  canManageRegistration: boolean;
  canAddNewTeams: boolean;
  id: string;
  inheritedFromOrganization: boolean;
  name: string;
  orgAdmin: boolean;
  organization: any;
  processingFeeSubscriptionId: string | null;
  subscriptionDateCancelled: string | null;
  subscriptionDateCreated: string | null;
  subscriptionDeadline: string | null;
  subscriptionId: string | null;
  processingFeePerMil: number | null;
  processingFeeCents: number | null;
  teams: UserOrganizationsAndTeams[];
  siteKey: string;
  limitedFunctionality: boolean | null;
  licenseSubscriptions: any[] | null;
  activeTeamCount: number | null;
  licenseCount: number | null;
  dataSubscriptionStatus: string | null;
  subscriptionOverride: boolean | null;
}
export interface Player {
  address: string;
  city: string;
  dateCreated: number;
  gender: string;
  grade: string;
  pantsSize: string;
  school: string;
  shirtSize: string;
  state: string;
  zip: string;
  id: string;
  firstName: string;
  lastName: string;
  jerseyNumber: number;
  name: string;
  orgUnits: {
    id: string;
    name: string;
    organizationName: string | null;
    qualifiedName: string;
    type: string;
    tags: string[];
    isOrganization: boolean;
    dateCreated: number;
    dateArchived: number | null;
    chatEnabled: boolean;
  }[];
  userInvites: { email: string; inviteType: string }[];
  users: {
    firstName: string;
    lastName: string;
    id: string;
    fullName: string;
  }[];
}
export interface PlayersAndTeams {
  organizations: UserOrganizationsAndTeams[];
  following: any[];
  players: Player[];
}

export interface AuthExpirationToken {
  refreshTokenExpiration: number;
  authTokenExpiration: number;
}

export interface MyPlayersByTeam {
  chatEnabled: boolean;
  dateArchived: number | null;
  dateCreated: number;
  id: string;
  isOrganization: boolean;
  //indicates if the current user viewing the player is following the player or a fan of the player
  isFollower: boolean;
  myPlayers: Player[];
  players: Player[];
  name: string;
  qualifiedName: string;
  organization: {
    id: string;
    name: string;
    organizationName: string | null;
    qualifiedName: string;
    type: string;
    tags: string[];
    isOrganization: boolean;
    dateCreated: number;
    dateArchived: number | null;
    chatEnabled: boolean;
  };
  tag: {
    id: string;
    name: string;
    organizationId: string;
  }[];
  type: string;
}
